import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";
import type * as type from "@vTypes";

export function useWantedStatusQuery({
  year,
  month,
  groupId,
  enabled,
}: {
  year: number | null | undefined;
  month: number | null | undefined;
  groupId?: string | null;
  enabled?: boolean;
}) {
  return useQuery<type.WantedStatus>({
    queryKey: QUERY_KEYS.wanted.status(year ?? 0, month ?? 0, groupId ?? ""),
    queryFn: async () => {
      if (!year || !month) {
        throw new Error("Year and month are required");
      }
      const params: { year: number; month: number; group_id?: string } = {
        year,
        month,
      };
      if (groupId && groupId.trim() !== "" && groupId !== "null") {
        params.group_id = groupId;
      }
      return await httpClient.get<type.WantedStatus>(`/wanted/status`, {
        params,
      });
    },
    enabled:
      enabled !== false && !!year && !!month && !(groupId && groupId === ""),
    staleTime: 1000 * 60 * 5, // 5분간 캐시
  });
}
